import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "flex flex-col gap-3 w-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScheduleConfigSkeleton = _resolveComponent("ScheduleConfigSkeleton")!

  return (_ctx.loading)
    ? (_openBlock(), _createBlock(_component_ScheduleConfigSkeleton, { key: 0 }))
    : (_openBlock(), _createBlock("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default"),
        _renderSlot(_ctx.$slots, "main-extra")
      ]))
}